
// ANONYMOUS EXAM RECORD
export const GET_ANONYMOUS_EXAM_RECORDS = "/anonymous-exam-records";
export const ADD_NEW_ANONYMOUS_EXAM_RECORD = "/anonymous-exam-records";
export const UPDATE_ANONYMOUS_EXAM_RECORD = "/anonymous-exam-records";
export const DELETE_ANONYMOUS_EXAM_RECORD = "/anonymous-exam-records";
export const GET_ANONYMOUS_EXAM_RECORDS_FOR_TEACHER = "/teachers/me/anonymous-exam-records";

// LAST ADD FOR SEARCH BY BARCODE
export const GET_ANONYMOUS_RECORD_BY_BARCODE = "/anonymous-exam-records/barcode";
export const UPDATE_ANONYMOUS_RECORD_NOTE = "/anonymous-exam-records";


// FOR GENERATE ANONYMOUS RECORDS
export const GENERATE_ANONYMOUS_RECORDS = "/evaluations";